module.exports = __webpack_public_path__ + "img/supporto_hdtool.142f16e6.png";